/// <amd-module name="Likes/SocialTelemetry" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssNavigationService } from "VSS/Platform/Navigation";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";

export namespace SocialCustomerIntelligenceConstants {
    export const AREA = "Social";
    export const LIKE_TOGGLE_CLICK = "ToggleLikesClick";
}

export class SocialTelemetry {
    private readonly _telemetryService: IVssTelemetryService;
    private readonly _navigationService: IVssNavigationService;

    constructor(pageContext: IVssPageContext) {
        this._telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        this._navigationService = pageContext.getService<IVssNavigationService>("IVssNavigationService");
    }

    /**
     * Logged when the user likes or unlikes an item.
     * @param artifactType {string} the type of the artifact being liked.
     * @param liked {boolean} true if the item is being liked, false if it is being unliked.
     */
    public logToggleLikeClicked(artifactType: string, liked: boolean): void {
        let ciData: { [key: string]: any } = {
            "artifactType": artifactType,
            "liked": liked
        };

        this.publish(SocialCustomerIntelligenceConstants.LIKE_TOGGLE_CLICK, ciData);
    }

    private publish(featureName: string, ciData: { [key: string]: any } = {}, immediate: boolean = false): void {
        let routeId = this._navigationService.getCurrentRoute().routeId;
        ciData["routeId"] = routeId;

        this._telemetryService.publishEvent(SocialCustomerIntelligenceConstants.AREA, featureName, ciData);
    }
}
